module.exports = __webpack_public_path__ + "img/qtjd.a3c4c10b.svg";